var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBindIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.002,
    viewBox: "0 0 20 20.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_401",
    "data-name": "Union 401",
    d: "M2691.617-5957.618a5.538,5.538,0,0,1,0-7.823l2.794-2.794a5.539,5.539,0,0,1,7.823,0,1.186,1.186,0,0,1,0,1.677,1.186,1.186,0,0,1-1.677,0,3.163,3.163,0,0,0-4.47,0l-2.794,2.793a3.164,3.164,0,0,0,0,4.471,3.137,3.137,0,0,0,2.235.926,3.137,3.137,0,0,0,2.235-.926l1.15-1.15a1.187,1.187,0,0,1,1.677,0,1.186,1.186,0,0,1,0,1.677l-1.151,1.15a5.493,5.493,0,0,1-3.912,1.621A5.494,5.494,0,0,1,2691.617-5957.618Zm6.147-6.147a1.185,1.185,0,0,1,0-1.676,1.185,1.185,0,0,1,1.677,0,3.141,3.141,0,0,0,2.235.926,3.139,3.139,0,0,0,2.235-.926l2.794-2.794a3.165,3.165,0,0,0,0-4.47,3.165,3.165,0,0,0-4.471,0l-1.15,1.151a1.187,1.187,0,0,1-1.677,0,1.186,1.186,0,0,1,0-1.677l1.151-1.15a5.537,5.537,0,0,1,7.823,0,5.538,5.538,0,0,1,0,7.823l-2.794,2.793a5.492,5.492,0,0,1-3.912,1.621A5.493,5.493,0,0,1,2697.764-5963.766Z",
    transform: "translate(-2690 5976)",
    fill: "#474b4f",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBindIcon);
export default __webpack_public_path__ + "static/media/bind_icon.0169f3b5a617ea3badb61a97a905c1ab.svg";
export { ForwardRef as ReactComponent };